import { render, staticRenderFns } from "./userRegistV2.vue?vue&type=template&id=3af4036a&scoped=true"
import script from "./userRegistV2.vue?vue&type=script&lang=js"
export * from "./userRegistV2.vue?vue&type=script&lang=js"
import style0 from "./userRegistV2.vue?vue&type=style&index=0&id=3af4036a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af4036a",
  null
  
)

export default component.exports